import React, { useEffect, useState } from "react";
import { useZxing } from "react-zxing";

function OurBarcodeComponent(props) {

    const {toggleBarcodeScannerView, resultGotAfterBarcodeScan} = props

    const [result, setResult] = useState("");
    const { ref } = useZxing({
        onDecodeResult(result) {
            setResult(result.getText());
        },
    });

    useEffect(()=>{

        if(result.length > 0){

            resultGotAfterBarcodeScan(result)
            toggleBarcodeScannerView()
        }

    },[result])

    return (
        <div style={{ position: "absolute", backgroundColor: "#00000090", top: 0, width: "100%", height: "100%", zIndex: 3, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            
            <button className="btn btn-primary" onClick={()=>toggleBarcodeScannerView()}>Close</button>

            <div>
                <video ref={ref} />
                <p>
                    <span>Last result:</span>
                    <span>{result}</span>
                </p>
            </div>


        </div>
    )

}

export default OurBarcodeComponent